import {
  ApplyItemDetailModel,
  HideListItemModel,
  LimitedListItemModel,
} from "models";
import React, { ChangeEvent } from "react";

type PROPS = {
  data: ApplyItemDetailModel;
  limitedLists: LimitedListItemModel[];
  hideLists: HideListItemModel[];
  disabled?: boolean;
};

const ListSelectForm: React.FC<PROPS> = (props) => {
  const [items, setItems] = React.useState<
    { label: string; id: string; list_type: number; list_id: string }[]
  >([]);
  const [selectedID, setSelectedID] = React.useState("");

  const onChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    const target = items.find((v) => v.id === value);
    if (target) {
      setSelectedID(value);
      console.log(target);
      props.data.list_type = target.list_type;
      props.data.list_id = target.list_id;
    } else {
      setSelectedID("");
      props.data.list_type = null;
      props.data.list_id = "";
    }
  };

  React.useEffect(() => {
    const items = [];
    items.push(
      ...props.limitedLists.map((v, i) => {
        return {
          label: v.limited_list_name + "(限定公開)",
          id: "lim-" + v.limited_list_id,
          list_type: 1,
          list_id: v.limited_list_id,
        };
      })
    );
    items.push(
      ...props.hideLists.map((v, i) => {
        return {
          label: v.hide_list_name + "(非公開)",
          id: "hide-" + v.hide_list_id,
          list_type: 2,
          list_id: v.hide_list_id,
        };
      })
    );
    setItems(items);
  }, [props.limitedLists, props.hideLists]);

  React.useEffect(() => {
    if (props.data.list_type === 1) {
      setSelectedID("lim-" + props.data.list_id);
    } else if (props.data.list_type === 2) {
      setSelectedID("hide-" + props.data.list_id);
    } else {
      setSelectedID("");
    }
  }, [props.data.list_id, props.data.list_type]);

  return (
    <select value={selectedID} onChange={onChange} disabled={props.disabled}>
      <option>すべての範囲に公開</option>
      {items.map((v, i) => {
        return (
          <option key={i} value={v.id}>
            {v.label}
          </option>
        );
      })}
    </select>
  );
};

export default ListSelectForm;
